/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const approximateCountResponseSchema = z.object({
  count: z.int(),
});
